import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14.91 6.71a.9959.9959 0 00-1.41 0L8.91 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L11.03 12l3.88-3.88c.38-.39.38-1.03 0-1.41z"
}), 'NavigateBeforeRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigateBeforeRounded.js
// module id = 4993
// module chunks = 2